import App from './QuickCalcApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iQuickCalc', <App />);
